import * as React from 'react'

import { useArcadeMigrationFeatureFlag } from '../../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeButton, {
  ButtonProminence as ArcadeButtonProminence,
  ButtonSize as ArcadeButtonSize,
} from './ArcadeButton'
// eslint-disable-next-line @nx/workspace-no-mooncake-button
import MooncakeButton, { ButtonProps, ButtonSize as MooncakeButtonSize } from './MooncakeButton'

const translatableMooncakeVariants = ['primary', 'secondary', 'tertiary', 'tertiary-outline', 'outline']
type TranslatableMooncakeVariants = (typeof translatableMooncakeVariants)[number]
const mooncakeToArcadeProminenceMap: Record<TranslatableMooncakeVariants, ArcadeButtonProminence> = {
  primary: 'prominent',
  secondary: 'standard',
  tertiary: 'subtle',
  'tertiary-outline': 'subtle',
  outline: 'subtle',
}

const mooncakeToArcadeSizeMap: Record<MooncakeButtonSize, ArcadeButtonSize> = {
  large: 'cta',
  medium: 'default',
  small: 'compact',
  icon: 'compact',
}

const isTranslatableMooncakeVariant = (variant: string): variant is TranslatableMooncakeVariants =>
  translatableMooncakeVariants.includes(variant)

/**
 * @deprecated Use ArcadeButton instead
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const shouldUseArcadeButton = useArcadeMigrationFeatureFlag('button')

  if (shouldUseArcadeButton) {
    const { variant, size, loading, ...rest } = props

    const isDestructive = variant === 'error'

    let arcadeVariant: ArcadeButtonProminence = 'prominent'
    if (variant && isTranslatableMooncakeVariant(variant)) {
      arcadeVariant = mooncakeToArcadeProminenceMap[variant]
    }

    const arcadeSize = size ? mooncakeToArcadeSizeMap[size] : undefined

    return (
      <ArcadeButton
        ref={ref}
        prominence={arcadeVariant}
        size={arcadeSize}
        isLoading={loading}
        isDestructive={isDestructive}
        {...rest}
      />
    )
  }

  return <MooncakeButton ref={ref} {...props} />
})

export default Button
